
export const plus = `<svg aria-hidden="true" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
<path d="M30.112 14.108h-12.224v-12.22c0-1.042-0.846-1.888-1.888-1.888-1.038 0-1.888 0.846-1.888 1.888v12.22l-12.224 0.004c-1.042 0-1.888 0.846-1.888 1.888s0.846 1.888 1.888 1.888l12.224-0.004v12.224c0 1.042 0.842 1.888 1.888 1.888 1.038 0 1.888-0.846 1.888-1.888v-12.224h12.22c1.042 0 1.888-0.846 1.888-1.888s-0.842-1.888-1.884-1.888z"></path>
</svg>`;
